import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildVisitedHosts } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function HostsPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const hosts = buildVisitedHosts(ranged, currentSite?.domain || '');
  const total = hosts.reduce((sum, h) => sum + h.value, 0) || 1;
  const columns = ['受访域名', '浏览量', '占比'];
  const rows = hosts.map((h) => [h.name, formatNumber(h.value), `${Math.round((h.value / total) * 100)}%`]);

  if (!currentSite) return <EmptyState title="先添加一个站点" desc="添加站点后可查看受访域名。" />;

  return (
    <div>
      <PageHeader
        title="受访域名"
        desc="同一套统计代码覆盖的域名访问分布。"
        range={range}
        extra={<ExportButton filename={`${currentSite.domain}-hosts.csv`} columns={columns} rows={rows} />}
      />
      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable columns={columns} rows={rows} empty="当前时段暂无受访域名数据" />
      </div>
    </div>
  );
}
